<template>
    <div>
        <QHfileList v-model="values" @remove="remove"></QHfileList>
        <Upload :action="action" :on-success="success" :on-error="error" :on-remove="stop"
            :on-format-error="formatError" :format="format" :accept="accept" :max-size="size"
            :on-exceeded-size="exceededSize" :show-upload-list="loading" :before-upload="before" 
            :headers="headers"
            ref="upload"
            v-if="max > values.length">
            <Button icon="ios-cloud-upload-outline">上传专利PDF文件(最大5M)</Button>
        </Upload>
    </div>
</template>

<script>

export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            loading: false,
            action: this.$config.api + '/os/Uploads/uploadFile',
            headers:{
                'token': localStorage.getItem('token')
            },
            values: [],
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        value: {
            type: [Array, String],
            default: () => {
                return [];
            }
        },
        accept: {
            type: String,
            default: "image/*"
        },
        format: {
            type: Array,
            default: ['jpg', 'jpeg', 'png']
        },
        max: {
            type: Number,
            default: 3
        },
        size: {
            type: Number,
            default: 2048
        }
    },


    // +----------------------------------------------------------------------
    // | Desc:watch
    // +----------------------------------------------------------------------
    watch: {
        value() {
            this.setValue();
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        setValue() {
            this.values = this.value || [];
        },
        getValue() {
            this.$emit('input', this.values);
        },
        before() {
            this.loading = true;
        },
        success(response) {
            this.loading = false;
            this.$refs.upload.fileList = [];
            if (response.code == 0) {
                this.values.push(response.data);
                this.getValue();
            } else {
                this.$msg(response.msg, "error");
            };
        },
        error() {
            this.$msg("上传失败：未知错误", "error");
            this.$refs.upload.fileList = [];
        },
        remove() {
            this.getValue();
        },
        stop() {
            this.$refs.upload.fileList = [];
        },
        formatError() {
            this.$refs.upload.fileList = [];
            this.$msg("文件格式错误:只能是" + this.format.join(","), "error");
        },
        exceededSize() {
            this.$refs.upload.fileList = [];
            this.$msg("文件大小超限:不能超过" + this.size + "kb", "error");
        },
    }
}
</script>
